export enum CookiesBannerAcknowledgementState {
  NO_ACTION,
  ACCEPTED,
}
